module.exports = __webpack_public_path__ + "static/media/meeting.b555512b.png";